<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useTemplateRef, watch } from 'vue';
import { useRoute } from '#app/composables/router';
import { useErrorStore } from '#layers/ui/stores/error';
import ErrorScreen from './ErrorScreen.vue';

const route = useRoute();

watch(route, () => {
	clearError();
});

const errorBoundary = useTemplateRef('errorBoundary');
const errorStore = useErrorStore();
const { globalError } = storeToRefs(errorStore);

function clearError() {
	errorBoundary.value?.clearError();
	errorStore.clearGlobalError();
}
</script>

<template>
	<ErrorScreen v-if="globalError" :error="globalError" :clear-error />
	<NuxtErrorBoundary
		v-else
		ref="errorBoundary"
	>
		<slot />

		<template #error="{ error }">
			<ErrorScreen :error :clear-error />
		</template>
	</NuxtErrorBoundary>
</template>
